import React, { useState, useMemo } from 'react';
import { useHistory } from 'react-router-dom';

import Grid from '@material-ui/core/Grid';

import DriveFolder from './DriveFolder';
import DriveFile from './DriveFile';
import KitFile from './KitFile';

import routes from '../../constants/routes';
// import FolderIcon from '../../assets/icons/FolderIcon';
import TurnBackIcon from '../../assets/icons/TurnBackIcon';

const views = {
  LOAN: 'LOAN',
  CONSIGNMENT: 'CONSIGNMENT',
};

const DriveBrowse = (props) => {
  const { folders, files, onFolderClick, onFileClick, active, kits = [] } = props;
  const history = useHistory();

  const [view, setView] = useState(views.LOAN);

  const kitsList = useMemo(() => {
    if (view === views.LOAN) {
      return kits.filter((k) => !k?.isConsignment);
    } else if (view === views.CONSIGNMENT) {
      return kits.filter((k) => !!k?.isConsignment);
    } else {
      return kits;
    }
  }, [kits, view]);

  return (
    <div className='drive-browse__container'>
      {active === 'kits' ? (
        <>
          { kits && !!kits.length && (
            <>
              <span className='secondary font-bold font-size-bg m-b-lg'>{view === views.CONSIGNMENT ? 'Consignment Kits' : 'Loan Kits'}</span>
              <Grid container spacing={0}>
                {view === views.CONSIGNMENT && (
                  <Grid item xs={12} sm={6} md={6} lg={4}>
                      <div className='drive-folder__container' onClick={() => setView(views.LOAN)}>
                        <div className='drive-folder-icon'>
                        <TurnBackIcon fontSize='large' color='var(--app-text)' />
                      </div>
                      <div className='drive-folder-name__container'>
                        <div className='font-size-bg font-bold'>
                          Back to Loan Kits
                        </div>
                      </div>
                    </div>
                  </Grid>
                )}
                {view === views.LOAN && (
                  <Grid item xs={12} sm={6} md={6} lg={4}>
                    <DriveFolder
                      id='consignment_kits'
                      name='Consignment Kits'
                      onClick={() => setView(views.CONSIGNMENT)}
                      hideDate
                    />
                  </Grid>
                )}
                {
                  kitsList.map((kit) => (
                    <Grid key={kit.id} item xs={12} sm={6} md={6} lg={4}>
                      <KitFile
                        {...kit}
                        onClick={() => {
                          if (!!kit?.isParent) {
                            history.push(`${routes.PARENT_KIT}/${kit.id}?redirect=drive`);
                          } else {
                            history.push(`${routes.BILL_OF_MATERIAL}/${kit.id}?redirect=drive`);
                          }
                        }}
                      />
                    </Grid>
                  ))
                }
              </Grid>
            </>
          )}
        </>
      ) : (
        <>
          { folders && !!folders.length && (
            <>
              <span className='secondary font-bold font-size-bg m-b-lg'>Folders</span>
              <Grid container spacing={0} className='m-b-lg'>
                {
                  folders.map((folder) => (
                    <Grid key={folder.id} item xs={12} sm={6} md={6} lg={4}>
                      <DriveFolder
                        {...folder}
                        onClick={onFolderClick}
                      />
                    </Grid>
                  ))
                }
              </Grid>
            </>
          )}

          { files && !!files.length && (
            <>
              <span className='secondary font-bold font-size-bg m-b-lg'>Files</span>
              <Grid container spacing={0}>
                {
                  files.map((file) => (
                    <Grid key={file.id} item xs={12} sm={6} md={6} lg={4}>
                      <DriveFile
                        {...file}
                        onClick={onFileClick}
                      />
                    </Grid>
                  ))
                }
              </Grid>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default DriveBrowse;
